(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("monerisHostedPayPageConfirmation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            template: "<div sb-loading class='well'></div>",
            controller: ["checkoutResource", "checkoutService", "messageService", "$state", MonerisHostedPayPageConfirmationCtrl],
            controllerAs: "vm"
        };
        function MonerisHostedPayPageConfirmationCtrl(checkoutResource, checkoutService, messageService, $state) {
            //Moneris hostedPage is using GET
            var search = location.search.substring(1);
            //var search = "response_order_id=040798f9-f175-4a07-aaac-de3da76c5af2&date_stamp=2017-03-15&time_stamp=16:57:37&bank_transaction_id=660144990016410940&charge_total=3.00&bank_approval_code=984392&response_code=027&iso_code=01&txn_num=142113-0_11&message=APPROVED%20%20%20%20%20%20%20%20%20%20%20*%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3D&trans_name=purchase&cardholder=sara&f4l4=2222***0011&card=M&expiry_date=1708&result=1&avs_response_code=R&cvd_response_code=P&bill_first_name=&bill_last_name=&bill_company_name=&bill_address_one=&bill_city=&bill_state_or_province=&bill_postal_code=&bill_country=&bill_phone=&bill_fax=&email=&cust_id=&note=";
            var responseDetails = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value); }) : {};
            //FL - Moneris hostedPage is using POST
            //God knows
            var model = {
                monerisResponse: JSON.stringify(responseDetails),
                updateAddress: checkoutService.model.billingAddress.saveToAccount
            };
            checkoutResource.processMonerisPaymentResponse(model, function (transaction) {
                if (transaction.value) {
                    //all is good
                    checkoutService.wizard.isStep4Valid = true;
                    $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
                }
                else {
                    //Transaction is either declined or canceled by user
                    checkoutService.model.error = true;
                    //messageService.error("storefront.checkout.error.paymentFailed.moneris");
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                }
            }, function (error) {
                messageService.error(error);
                $state.go("main.checkout.step3", {}, { location: "replace" });
            });
        }
    });
}());
